export default __webpack_public_path__ + "static/media/twitter-team-link.5001f05b.svg";